export default {
  103: {
    id: 103,
    name: 'Physical Therapist',
    group: 'Category',
    category: 'Instruction',
    groupLabel: 'Category Name',
    categoryLabel: 'Instruction',
  },
  100: {
    id: 100,
    name: 'Common',
    group: 'Category',
    category: 'Instruction',
    groupLabel: 'Category Name',
    categoryLabel: 'Instruction',
  },
};



// WEBPACK FOOTER //
// ./src/config/templates.js